import { parseInboundPayload } from '../../inbound';
import { booleanParser, encodedStringParser, numberParser } from '../../inboundParsers';
import { trimBraces } from '../../inboundUtils';
const mttStagingTablePartDefinitions = [
    { name: 'roomId', parser: numberParser },
    { name: 'tableNum', parser: numberParser },
    { name: 'statusString', parser: encodedStringParser },
    { name: 'isActive', parser: booleanParser },
    { name: 'playersStringHtml', parser: encodedStringParser }
];
export function mttStagingTableParser(str) {
    const inboundParts = trimBraces(str).split(',');
    return parseInboundPayload(inboundParts, mttStagingTablePartDefinitions);
}
